export function RefreshingTimeslots() {
  return (
    <div className="mb-10 flex flex-col items-center">
      <div className="text-sm text-acai-900">
        <span>Refreshing </span>
        <span className="font-serif italic">timeslots</span>
      </div>
      <div className="relative flex !h-[2px] !w-[200px] bg-clay-100">
        <div className="product_list__loader__line" />
      </div>
    </div>
  );
}
